import { useMemo, useState } from "react";
import { money } from "../calc";
import { generateClientReportPDF } from "../pdf";

export default function ServiceClientReport({ services, settings }) {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const rows = useMemo(() => {
    const map = {};
    services.filter((s) => s.status !== "cancelado" && String(s.date).slice(0, 7) === month).forEach((s) => {
      const k = s.clientId || "sem";
      const r = (map[k] = map[k] || { name: s.clientName || "Sem cliente", count: 0, total: 0, paid: 0, pending: 0, cost: 0 });
      const v = Number(s.revenue || 0);
      r.count += 1; r.total += v; r.cost += Number(s.cost || 0);
      if (s.status === "pago") r.paid += v; else r.pending += v;
    });
    return Object.values(map).sort((a, b) => b.pending - a.pending || b.total - a.total);
  }, [services, month]);
  const tot = rows.reduce((t, r) => ({ count: t.count + r.count, total: t.total + r.total, paid: t.paid + r.paid, pending: t.pending + r.pending }), { count: 0, total: 0, paid: 0, pending: 0 });

  return (
    <article className="card" data-testid="client-report">
      <div className="card-head">
        <h2>Faturamento por cliente</h2>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} style={{ maxWidth: 170 }} data-testid="client-report-month" />
          <button className="secondary" onClick={() => generateClientReportPDF(rows, tot, month, settings)} disabled={!rows.length} data-testid="client-report-pdf">PDF para cobrança</button>
        </div>
      </div>
      {rows.length === 0 ? <p className="hint" data-testid="client-report-empty">Nenhum serviço neste mês.</p> : (
        <div style={{ overflowX: "auto" }}>
          <table className="report-table" data-testid="client-report-table">
            <thead><tr><th>Cliente</th><th>Serviços</th><th>Faturado</th><th>Recebido</th><th>A receber</th></tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.name + i} data-testid={`client-report-row-${i}`}><td>{r.name}</td><td>{r.count}</td><td>{money(r.total)}</td><td>{money(r.paid)}</td><td style={{ color: r.pending ? "#b06a00" : undefined, fontWeight: 800 }}>{money(r.pending)}</td></tr>
              ))}
              <tr className="total-row" data-testid="client-report-total"><td><strong>Total</strong></td><td>{tot.count}</td><td><strong>{money(tot.total)}</strong></td><td><strong>{money(tot.paid)}</strong></td><td><strong>{money(tot.pending)}</strong></td></tr>
            </tbody>
          </table>
        </div>
      )}
    </article>
  );
}
